import { useEffect, useState } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { trackEvent } from '../../../helpers/analytics';
import usePageHook from '../../../hooks/usePageHook';
import { userSelector } from '../../../redux/selectors';
import { useGetSharedListBySlugQuery } from '../../../services/sharedLists';

export const useSharedCompanyList = () => {
  const { slug } = useParams();
  const user = useSelector(userSelector);
  const { pathname } = useLocation();
  const [isUserOnboarded, setIsUserOnboarded] = useState(
    !!user.email && !!user.confirmed && user.linkedinSync != null && !pathname.includes('share-contacts'),
  );
  const { data, isLoading: isFetchingPreview, error } = useGetSharedListBySlugQuery({ slug });
  const history = useHistory();
  const isSyncActive = user?.linkedinSync?.syncStatus === 'active' && !!user?.linkedinSync?.contactsImportInProgress;

  usePageHook(data?.sharedList?.name, { networkName: data?.sharedList?.collection?.name });

  useEffect(() => {
    if (!user?.email && !pathname.includes('user')) {
      history.push(`/shared-company-lists/${slug}/user`);
    } else if (!!user.email && !user.confirmed) {
      history.push(`/shared-company-lists/${slug}/verify-email`);
    } else if (!!user.email && !user.onboardingCompleted) {
      history.push(`/shared-company-lists/${slug}/user/profile`);
    } else if (
      !!user.email &&
      user.linkedinSync == null &&
      !pathname.includes('install-extension') &&
      !pathname.includes('share-contacts') &&
      !pathname.includes('user')
    ) {
      history.push(`/shared-company-lists/${slug}/install-extension`);
    } else if (
      !!user.email &&
      !!user.linkedinSync &&
      !!user.confirmed &&
      !isUserOnboarded &&
      !pathname.includes('share-contacts')
    ) {
      history.push(`/shared-company-lists/${slug}`);
      setIsUserOnboarded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (data?.sharedList) {
      trackEvent('shared_list:view_shared_list', {
        collectionId: data?.sharedList?.collection?.id,
        listSlug: data?.sharedList?.slug,
        objectType: 'companies',
        viewMode: 'table',
      });
    }
  }, [data?.sharedList]);

  return {
    sharedList: data?.sharedList,
    sharedListError: error,
    user,
    isFetchingPreview,
    isUserSignedIn: !!user.email,
    isSyncActive,
    isUserOnboarded,
    setIsUserOnboarded,
  };
};
